import useNewspaperTableColumns from './useNewspaperTableColumns'

export default useNewspaperTableColumns
